import React, { useEffect, useRef, useState } from "react";
import "react-chat-elements/dist/main.css";
import { useTranslation } from "react-i18next";
import {
  getServiceProviderUserChatAction,
  getServiceProviderUserChatDetailsByIdAction,
  sendUserChatMessageAction,
} from "../../../../../redux/services/service-provider-user-chat/serviceProviderUserChatServices";
import { useDispatch, useSelector } from "react-redux";
import useLocalStorage from "../../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../../constants/config/appConfig";
import ChatComponent from "../../../../common/chat-component/ChatComponent";
// import { socket } from "../../../../../socket";
import styles from "./TicketManagement.module.scss";
import {
  getTicketManagementChatByIdAction,
  sendSuperAdminChatMessageAction,
  startSupportTicketChatConversationAction,
} from "../../../../../redux/services/ticket-management/ticketManagementServices";
import { useNavigate } from "react-router-dom";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../constants/routeConsts";
import { io } from "socket.io-client";

const TicketManagementChat = () => {
  const socketUrl =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : `${window.location.protocol}//${window.location.host}`;

  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  /*loading dependencies */
  const [loading, setLoading] = useState(false);
  /*loading dependencies */

  /* local storage dependencies */
  const { userSession } = useLocalStorage(appConfig.SESSION_USER_INFO);
  /* local storage dependencies */

  /* ticket management messages */
  const [ticketManagementChatMessages, setTicketManagementChatMessages] =
    useState([]);
  const [ticketManagementChatTitle, setTicketManagementChatTitle] = useState(
    {}
  );
  const [conversationId, setConversationId] = useState("");
  /* ticket management messages */

  const { loginDetails } = useSelector((state) => state.auth);

  /* table dependencies */
  const { selectedTicketManagementChatIdDetails } = useSelector(
    (state) => state.tickets
  );
  /* table dependencies */

  useEffect(() => {
    if (
      selectedTicketManagementChatIdDetails?.selectedChatConversationId &&
      selectedTicketManagementChatIdDetails?.selectedTicketManagementId !==
        null &&
      selectedTicketManagementChatIdDetails?.selectedChatConversationId !==
        "" &&
      selectedTicketManagementChatIdDetails?.selectedChatConversationId !==
        undefined
    ) {
      const dataToBeSent = {
        selectedConversationId:
          selectedTicketManagementChatIdDetails?.selectedChatConversationId,
      };
      dispatch(
        getTicketManagementChatByIdAction(dataToBeSent, setLoading)
      ).then((apiRes) => {
        setTicketManagementChatMessages(apiRes?.messages);
        setTicketManagementChatTitle(apiRes);
      });

      // socket.emit("chat-room-joined", {
      //   username: userSession?.userName,
      //   user_id: loginDetails?._id,
      //   userrole: userSession?.userRole,
      //   room: selectedTicketManagementChatIdDetails?.selectedChatConversationId,
      // });
    } else {
      navigate(baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT));
    }
  }, []);

  // useEffect(() => {
  //   function handleChatMessage(res) {
  //     setTicketManagementChatMessages((prevValue) => [...prevValue, res]);
  //   }

  //   socket.on("chat-message", handleChatMessage);

  //   return () => {
  //     socket.off("chat-message", handleChatMessage);
  //   };
  // }, [ticketManagementChatMessages]);

  function handleChatMessage(res) {
    setTicketManagementChatMessages((prevValue) => {
      if (prevValue?.[0].conversation_id === res?.conversation_id) {
        if (prevValue) {
          return [...prevValue, res];
        } else {
          return [res];
        }
      }
    });
  }

  /* on submit */
  const onSubmit = (values) => {
    const dataToBeSent = {
      ...values,
      conversation_id:
        selectedTicketManagementChatIdDetails?.selectedChatConversationId,
    };
    dispatch(sendSuperAdminChatMessageAction(dataToBeSent, setLoading)).then(
      (res) => {
        const dataToBeSentToGetChat = {
          selectedConversationId:
            selectedTicketManagementChatIdDetails?.selectedChatConversationId,
        };
        dispatch(
          getTicketManagementChatByIdAction(dataToBeSentToGetChat, setLoading)
        ).then((apiRes) => {
          setTicketManagementChatMessages(apiRes?.messages);
          setTicketManagementChatTitle(apiRes);
        });
      }
    );
  };

  useEffect(() => {
    const socket = io(socketUrl);
    setInterval(() => {
      socket.on("connect", () => {
        console.log("socket connection==", socket.connected); // true
        socket.emit(
          "chat-room-joined",
          {
            username: userSession?.userName,
            user_id: userSession?.userId,
            userrole: userSession?.userRole,
            room: selectedTicketManagementChatIdDetails?.selectedChatConversationId,
            metadata: "",
          },

          (data) => {}
        );

        socket.on("chat-message", (res) => {
          handleChatMessage(res);
        });
      });
    }, [2000]);

    return () => {
      // Event listeners cleanup
      socket.emit("chat-room-leaved", (data) => {});
      socket.disconnect();
    };
  }, []);

  const intervalRef = useRef(null);

  useEffect(() => {
    const messageInterval = () => {
      intervalRef.current = setInterval(() => {
        const dataToBeSent = {
          selectedConversationId:
            selectedTicketManagementChatIdDetails?.selectedChatConversationId,
        };
        dispatch(
          getTicketManagementChatByIdAction(dataToBeSent, setLoading)
        ).then((apiRes) => {
          setTicketManagementChatMessages(apiRes?.messages);
          setTicketManagementChatTitle(apiRes);
        });
      }, 3000);
    };

    messageInterval();

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [selectedTicketManagementChatIdDetails]);

  /* on submit */
  return (
    <>
      <ChatComponent
        chatList={[]}
        chatMessages={ticketManagementChatMessages}
        selectedUserDetails={ticketManagementChatTitle}
        onChatClicked={() => {}}
        onSubmit={onSubmit}
        disabled={false}
        isChat={true}
        isChatList={false}
        backButtonDetails={{
          isBackButton: true,
          navigate: baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT),
        }}
      />
    </>
  );
};

export default TicketManagementChat;
